module.exports = __webpack_public_path__ + "img/card-Fade.f641ef74.png";